import { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  selectSelectedLocation,
  setSelectedLocationSuccess,
} from '#/shared/slices/location';
import { getAndSetLocationLabel } from '#/shared/queries/location';

export default () => {
  const dispatch = useDispatch();
  const selectedLocation = useSelector(selectSelectedLocation, shallowEqual);

  const setSelectedLocation = useCallback(
    location => {
      dispatch(setSelectedLocationSuccess(location));
    },
    [dispatch]
  );

  const setSelectedLocationAndRedirect = useCallback(
    (location, pageToNavigate) => {
      if (location.name != null && location.name !== 'undefined') {
        dispatch(setSelectedLocationSuccess(location)).then(() => {
          pageToNavigate();
        });
      } else {
        dispatch(getAndSetLocationLabel(location.lat, location.lng)).then(
          locationData => {
            pageToNavigate(locationData);
          }
        );
      }
    },
    [dispatch]
  );

  return {
    selectedLocation,
    setSelectedLocation,
    setSelectedLocationAndRedirect,
  };
};
